import classNames from "classnames";
import styles from "../style.module.scss";
import { useFormik } from "formik";
import { UpdateProfileVS } from "shared/utils/validation";
import CustomInput from "shared/components/common/customInput";
import { Icons } from "assets";
import CustomButton from "shared/components/common/customButton";
import { useDispatch, useSelector } from "react-redux";
import { GetUserService, UpdateProfileService } from "shared/services/user";
import { useEffect } from "react";
import { setAuthReducer } from "shared/redux/reducers/authSlice";
import { toastMessage } from "shared/components/common/toast";

const Account = () => {
  const {
    auth: { user },
  } = useSelector((state: any) => state?.root);

  const dispatch = useDispatch();

  const initialValues: UpdateProfileType = {
    fullname: user?.name,
    email: user?.email,
    role: user?.roleInOrganization,
    orgName: user?.organization?.name,
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: UpdateProfileVS,
    onSubmit: () => {
      handleUpdateProfile();
    },
  });

  const {
    handleChange,
    handleSubmit,
    values,
    touched,
    errors,
    isSubmitting,
    setSubmitting,
  } = formik;

  const handleUpdateProfile = () => {
    setSubmitting(true);
    UpdateProfileService(values)
      .then(({ data, status }) => {
        if (status) {
          dispatch(
            setAuthReducer({
              user: data?.user,
            })
          );
          toastMessage("success", "Profile Updated Successfully");
        }
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleGetUser = () => {
    GetUserService()
      .then(({ data, status }) => {
        if (status) {
          dispatch(
            setAuthReducer({
              user: data?.user,
            })
          );
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    handleGetUser();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classNames("flex flex-col w-full", styles.mainContainer)}>
      <h3>Account Information</h3>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className={classNames("flex flex-col sm:flex-row gap-4")}>
          <CustomInput
            label="Full Name"
            placeholder="Mount Banyak"
            required
            type="text"
            value={values.fullname}
            error={touched.fullname && errors.fullname ? errors.fullname : ""}
            onChange={handleChange("fullname")}
            customLabelStyle={classNames(styles.labelStyle)}
            customInputStyle={classNames(styles.inputStyle)}
          />
          <CustomInput
            label="Email"
            placeholder="contact@mountbanyak.com"
            required
            Icon={Icons.Mail}
            type="email"
            value={values.email}
            onChange={handleChange("email")}
            customLabelStyle={classNames(styles.labelStyle)}
            customInputStyle={classNames(styles.inputStyle)}
            readOnly
          />
        </div>
        <div className={classNames("flex flex-col sm:flex-row gap-4")}>
          <CustomInput
            label="Role"
            placeholder="Employee"
            required
            type="text"
            value={values.role}
            error={touched.role && errors.role ? errors.role : ""}
            onChange={handleChange("role")}
            customLabelStyle={classNames(styles.labelStyle)}
            customInputStyle={classNames(styles.inputStyle)}
          />
          <CustomInput
            label="Organization Name"
            placeholder="RSA Conference"
            required
            type="text"
            value={values.orgName}
            onChange={handleChange("orgName")}
            customLabelStyle={classNames(styles.labelStyle)}
            customInputStyle={classNames(styles.inputStyle)}
            readOnly
          />
        </div>
        <CustomButton
          title="Save Changes"
          containerStyle={classNames("mt-4 ms-auto")}
          onClick={() => {
            handleSubmit();
          }}
          loading={isSubmitting}
          disabled={isSubmitting}
        />
      </form>
    </div>
  );
};

export default Account;
